import DeliveryOption from 'Component/DeliveryOption';
import MyAccountAddressTable from 'Component/MyAccountAddressTable';
import {
    MyAccountOrderInformation as SourceMyAccountOrderInformation
} from 'SourceComponent/MyAccountOrderInformation/MyAccountOrderInformation.component';

import './MyAccountOrderInformation.override.style';

/** @namespace PeggysagePwa/Component/MyAccountOrderInformation/Component */
export class MyAccountOrderInformationComponent extends SourceMyAccountOrderInformation {
    /**
     * Override
     * @returns {JSX.Element|null}
     */
    renderShippingMethod() {
        const {
            order: {
                shipping_method,
                shipping_method_code,
                total: {
                    shipping_handling: {
                        amount_excluding_tax: {
                            value: price_excl_tax = 0,
                            currency = 'EUR'
                        } = {},
                        amount_including_tax: {
                            value: price_incl_tax = 0
                        } = {}
                    } = {}
                }
            }
        } = this.props;

        if (!shipping_method) {
            return null;
        }

        const [carrier_code, method_code] = shipping_method_code.split('_', 2);
        const [carrier_title, method_title] = shipping_method.split(' - ', 2);

        const shippingMethodOption = {
            available: true,
            carrier_code,
            carrier_title,
            method_code,
            method_title,
            price_excl_tax,
            price_incl_tax
        };

        return (
            <div
              block="MyAccountOrderInformation"
              elem="ShippingMethod"
            >
                <DeliveryOption option={ shippingMethodOption } currency={ currency } />
            </div>
        );
    }

    /**
     * Override
     * @returns {JSX.Element|null}
     */
    renderShippingAddress() {
        const { order: { shipping_address } = {} } = this.props;

        if (!shipping_address) {
            return null;
        }

        return (
            <div
              block="MyAccountOrderInformation"
              elem="ShippingAddress"
            >
                <MyAccountAddressTable
                  address={ shipping_address }
                  mix={ { block: 'MyAccountOrderInformation', elem: 'Address' } }
                />
            </div>
        );
    }

    renderShipping() {
        return (
            <div
              block="MyAccountOrderInformation"
              elem="Column"
              mods={ { type: 'shippingAddress' } }
            >
                <div
                  block="MyAccountOrderInformation"
                  elem="ColumnTitle"
                >
                    <strong>
                        <span>{ __('Shipping') }</span>
                    </strong>
                </div>
                { this.renderShippingMethod() }
                { this.renderShippingAddress() }
            </div>
        );
    }

    /**
     * Override
     * @returns {JSX.Element}
     */
    renderContent() {
        return (
            <div
              block="MyAccountOrderInformation"
              elem="Information"
            >
                { this.renderShipping() }
                { this.renderBillingAddress() }
                { this.renderPaymentMethods() }
            </div>
        );
    }
}

export default MyAccountOrderInformationComponent;
